// Scroll reveal
const gpRevealObserver = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) e.target.classList.add('visible');
  });
}, { threshold: 0.12 });

document.querySelectorAll('.reveal').forEach(el => gpRevealObserver.observe(el));

// Namespaced global functions (avoids collision with Dawn and app scripts)
window.GlaucoProtect = window.GlaucoProtect || {};

window.GlaucoProtect.toggleFaq = function(el) {
  const item = el.parentElement;
  const wasOpen = item.classList.contains('open');
  item.closest('.faq-grid').querySelectorAll('.faq-item.open').forEach(i => {
    i.classList.remove('open');
    i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
  });
  if (!wasOpen) {
    item.classList.add('open');
    el.setAttribute('aria-expanded', 'true');
  }
};

window.GlaucoProtect.toggleMobileNav = function() {
  const overlay = document.getElementById('gpMobileNav');
  const hamburger = document.querySelector('.nav-hamburger');
  if (!overlay) return;
  const isOpen = overlay.classList.contains('open');
  if (isOpen) {
    overlay.classList.remove('open');
    setTimeout(() => { overlay.style.display = 'none'; }, 300);
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  } else {
    overlay.style.display = 'flex';
    requestAnimationFrame(() => overlay.classList.add('open'));
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
};

// Nav scroll shrink (cached query)
const gpNav = document.querySelector('.gp-nav');
if (gpNav) {
  window.addEventListener('scroll', () => {
    gpNav.style.padding = window.scrollY > 80 ? '14px 0' : '20px 0';
  }, { passive: true });
}

// Open first FAQ by default
document.addEventListener('DOMContentLoaded', () => {
  const firstFaq = document.querySelector('.faq-item .faq-question');
  if (firstFaq) firstFaq.click();
});
